const LOGIN_ROUTE = "login" as const;
const AUTH_WEBVIEW_ROUTE = "authWebView" as const;
const REGISTER_ROUTE = "register" as const;
const POLICY_LISTING_ROUTE = "choosePolicy" as const;
const POLICY_ACTION_ROUTE = "policyActions" as const;
const CONTACT_AGENT_ROUTE = "contactAgent" as const;
const MAKE_CLAIM_ROUTE = "reportClaim" as const;
const BILLING_PAYMENTS_ROUTE = "billingPayments" as const;
const DOCUMENTS_INFO_ROUTE = "documentsInfo" as const;
const DELETE_ACCOUNT_ROUTE = "deleteAccount" as const;
const RESET_PASSWORD_ROUTE = "resetPassword" as const;
const FORGOT_PASSWORD_ROUTE = "forgotPassword" as const;
const PDF_VIEWER_ROUTE = "pdfViewer" as const;
const SHAREABLE_ROUTE = "shareable" as const;
const ACCOUNT_DELETION = "accountDeletion" as const;
export {
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  POLICY_LISTING_ROUTE,
  POLICY_ACTION_ROUTE,
  CONTACT_AGENT_ROUTE,
  MAKE_CLAIM_ROUTE,
  BILLING_PAYMENTS_ROUTE,
  DOCUMENTS_INFO_ROUTE,
  DELETE_ACCOUNT_ROUTE,
  RESET_PASSWORD_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  PDF_VIEWER_ROUTE,
  AUTH_WEBVIEW_ROUTE,
  SHAREABLE_ROUTE,
  ACCOUNT_DELETION
};

export type RootStackParamList = {
  [LOGIN_ROUTE]: undefined;
  [REGISTER_ROUTE]: undefined;
  [POLICY_LISTING_ROUTE]: { fromNotification?: boolean } | undefined;
  [POLICY_ACTION_ROUTE]: undefined;
  [CONTACT_AGENT_ROUTE]: undefined;
  [MAKE_CLAIM_ROUTE]: undefined;
  [BILLING_PAYMENTS_ROUTE]: undefined;
  [DOCUMENTS_INFO_ROUTE]: undefined;
  [DELETE_ACCOUNT_ROUTE]: undefined;
  [RESET_PASSWORD_ROUTE]: undefined;
  [FORGOT_PASSWORD_ROUTE]: undefined;
  [PDF_VIEWER_ROUTE]: undefined;
  [AUTH_WEBVIEW_ROUTE]: undefined;
  [SHAREABLE_ROUTE]: undefined;
  [ACCOUNT_DELETION]: undefined;
};

export const screenTitles = {
  login: "Login",
  register: "Register",
  policyListing: "Choose A Policy",
  policyActions: "Policy Actions",
  contactAgent: "Contact My Agent",
  makeClaim: "Report A Claim",
  billingPayments: "Billing & Payments",
  documentsInfo: "Documents & Information",
  deleteAccount: "Delete Account",
  resetPassword: "Reset Password",
  forgotPassword: "Forgot Password",
  pdfViewer: "PDF Preview",
  authWebView: "Auth WebView",
  shareable: "Shareable",
  accountDeletion: "Account Deletion",
};
